import React, { useState, useEffect } from "react";
import axios from "axios";
import { Trash, AddIcon, TrashWhite, EditIcon } from "../../assets/icons/icons";
import { Link } from "react-router-dom";
import Pagination from "../section/Pagination";
import CustomAlert from "../CustomAlert";

export default function EditCoupons() {
  const [coupons, setCoupons] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [selectedCoupons, setSelectedCoupons] = useState([]);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [showDeleteSelectedDialog, setShowDeleteSelectedDialog] = useState(false);
  const [alert, setAlert] = useState(null);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    if (token) axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("https://laravel-api.aj-mart.com/api/coupon");
        setCoupons(res.data.coupon || []);
      } catch (error) {
        console.error("There was an error fetching the coupons:", error);
      }
    };
    fetchData();
  }, []);

  // صيغ التاريخ المناسبة لمدخل type="date"
  const dateForInput = (v) => (v ? String(v).slice(0, 10) : "");

  // فتح المودال مع تطبيع أسماء الحقول
  const handleEditClick = (data) => {
    setEditData({
      ...data,
      // إذا كان عندك أسماء قديمة، نحولها للأسماء الصحيحة
      coupon_start_date: data.coupon_start_date || data.start_day || "",
      coupon_end_date: data.coupon_end_date || data.end_day || "",
    });
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditData({});
  };

  // حفظ التعديلات
  const handleSaveChanges = async () => {
    try {
      const payload = {
        ...editData,
        // تأكد نبعث الحقول بالأسماء اللي الـ API يتوقعها
        coupon_start_date:
          editData.coupon_start_date || editData.start_day || "",
        coupon_end_date:
          editData.coupon_end_date || editData.end_day || "",
      };
      // نتخلص من مفاتيح قديمة لو موجودة
      delete payload.start_day;
      delete payload.end_day;

      const { data } = await axios.put(
        `https://laravel-api.aj-mart.com/api/coupon/update/${editData.coupon_id}`,
        payload
      );

      setAlert({ type: "success", message: "Coupon updated successfully" });

      // نحدث القائمة محلياً
      const updated = data.updated_coupon || payload;
      setCoupons((prev) =>
        prev.map((c) =>
          c.coupon_id === editData.coupon_id ? { ...c, ...updated } : c
        )
      );
      handleCloseModal();
    } catch (error) {
      console.error("There was an error updating the coupon:", error);
      setAlert({
        type: "error",
        message: "There was an error updating the coupon",
      });
    }
  };

  const handleDeleteCoupon = (coupon_id) => {
    if (!coupon_id) return;
    setShowDeleteDialog({ coupon_id });
  };

  const handleSelectCoupon = (coupon_id) => {
    setSelectedCoupons((prev) =>
      prev.includes(coupon_id)
        ? prev.filter((id) => id !== coupon_id)
        : [...prev, coupon_id]
    );
  };

  const handleSelectAll = () => {
    setSelectedCoupons((prev) =>
      prev.length === coupons.length ? [] : coupons.map((c) => c.coupon_id)
    );
  };

  const handleDeleteSelectedCoupons = () => {
    if (!selectedCoupons.length) {
      setAlert({
        type: "error",
        message: "Please select at least one coupon to delete",
      });
      return;
    }
    setShowDeleteSelectedDialog({ coupon_ids: selectedCoupons });
  };

  const confirmDeleteSelectedCoupons = async () => {
    try {
      await axios.delete("https://laravel-api.aj-mart.com/api/coupon/delete", {
        data: { coupon_ids: selectedCoupons },
      });
      setAlert({
        type: "success",
        message: "Selected coupons deleted successfully",
      });
      setCoupons((prev) =>
        prev.filter((c) => !selectedCoupons.includes(c.coupon_id))
      );
      setSelectedCoupons([]);
      setShowDeleteSelectedDialog(false);
    } catch (error) {
      console.error("Error deleting coupons:", error);
      setAlert({
        type: "error",
        message: "There was an error deleting the coupons",
      });
      setShowDeleteSelectedDialog(false);
    }
  };

  const confirmDeleteCoupon = async (coupon_id) => {
    try {
      await axios.delete(
        `https://laravel-api.aj-mart.com/api/coupon/delete/${coupon_id}`
      );
      setAlert({ type: "success", message: "Coupon deleted successfully" });
      setCoupons((prev) => prev.filter((c) => c.coupon_id !== coupon_id));
      setShowDeleteDialog(false);
    } catch (error) {
      console.error("There was an error deleting the coupon:", error);
      setAlert({
        type: "error",
        message: "There was an error deleting the coupon",
      });
      setShowDeleteDialog(false);
    }
  };

  const cancelDelete = () => setShowDeleteDialog(false);

  return (
    <section className="py-[25px]">
      {alert && (
        <CustomAlert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      )}

      <div className="main-title mb-[20px]">Edit Coupons</div>
      <div className="flex justify-end items-center gap-[10px] capitalize mb-[20px]">
        <Link to={"/addCoupon"} className="btn flex items-center gap-[5px]">
          <AddIcon />
          <span>Add Coupon</span>
        </Link>
        <button
          className="btn bg-red-500 hover:bg-red-600 flex items-center gap-2"
          onClick={handleDeleteSelectedCoupons}
        >
          <TrashWhite />
          <span>Delete Selected Coupons</span>
        </button>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-200 text-left">
          <thead className="bg-gray-100">
            <tr>
              <th className="border border-gray-200 p-[10px] capitalize">
                <input
                  type="checkbox"
                  className="w-[18px] h-[18px]"
                  checked={
                    coupons.length > 0 &&
                    selectedCoupons.length === coupons.length
                  }
                  onChange={handleSelectAll}
                />
              </th>
              <th className="border border-gray-200 p-[10px] capitalize">
                coupon name
              </th>
              <th className="border border-gray-200 p-[10px] capitalize">
                coupon code
              </th>
              <th className="border border-gray-200 p-[10px] capitalize">
                discount value
              </th>
              <th className="border border-gray-200 p-[10px] capitalize">
                Control tools
              </th>
            </tr>
          </thead>
          <tbody>
            {coupons.map((coupon) => (
              <tr className="bg-white hover:bg-gray-50" key={coupon.coupon_id}>
                <td className="border border-gray-200 p-[10px]">
                  <input
                    type="checkbox"
                    className="w-[18px] h-[18px]"
                    checked={selectedCoupons.includes(coupon.coupon_id)}
                    onChange={() => handleSelectCoupon(coupon.coupon_id)}
                  />
                </td>
                <td className="border border-gray-200 p-[10px]">
                  {coupon.coupon_name}
                </td>
                <td className="border border-gray-200 p-[10px]">
                  {coupon.coupon_code}
                </td>
                <td className="border border-gray-200 p-[10px]">
                  {coupon.coupon_discount}%
                </td>
                <td className="border border-gray-200 p-[10px]">
                  <div className="flex items-center gap-3">
                    <button
                      className="cursor-pointer"
                      onClick={() => handleEditClick(coupon)}
                      title="Edit"
                    >
                      <EditIcon />
                    </button>
                    <button
                      className="cursor-pointer"
                      onClick={() => handleDeleteCoupon(coupon.coupon_id)}
                      title="Delete"
                    >
                      <Trash />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
            {!coupons.length && (
              <tr>
                <td className="border border-gray-200 p-[10px]" colSpan={5}>
                  No coupons found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="py-[25px]">
        <Pagination />
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white w-[500px] rounded-lg shadow-lg p-[20px] relative">
            <h2 className="text-xl font-bold mb-[10px]">Edit Coupon</h2>
            <div className="flex flex-col gap-[10px] capitalize">
              <label className="text-sm font-medium">
                Coupon Name
                <input
                  type="text"
                  className="block w-full mt-1 p-[10px] capitalize border rounded"
                  value={editData.coupon_name || ""}
                  onChange={(e) =>
                    setEditData({ ...editData, coupon_name: e.target.value })
                  }
                />
              </label>

              <label className="text-sm font-medium">
                Coupon Code
                <input
                  type="text"
                  className="block w-full mt-1 p-[10px] capitalize border rounded"
                  value={editData.coupon_code || ""}
                  onChange={(e) =>
                    setEditData({ ...editData, coupon_code: e.target.value })
                  }
                />
              </label>

              <label className="text-sm font-medium">
                Discount Value
                <input
                  type="text"
                  className="block w-full mt-1 p-[10px] capitalize border rounded"
                  value={editData.coupon_discount || ""}
                  onChange={(e) =>
                    setEditData({
                      ...editData,
                      coupon_discount: e.target.value,
                    })
                  }
                />
              </label>

              <div className="flex items-center gap-[10px]">
                <div className="flex flex-col gap-[5px] w-[48%]">
                  <label className="text-black capitalize">Start Day</label>
                  <input
                    type="date"
                    className="px-[15px] py-[7px] outline-none border-2 border-[#1485a6] rounded-[4px] text-black bg-[#eeeeee6e] focus:ring-2"
                    value={dateForInput(editData.coupon_start_date)}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        coupon_start_date: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="flex flex-col gap-[5px] w-[48%]">
                  <label className="text-black capitalize">End Day</label>
                  <input
                    type="date"
                    className="px-[15px] py-[7px] outline-none border-2 border-[#1485a6] rounded-[4px] text-black bg-[#eeeeee6e] focus:ring-2"
                    value={dateForInput(editData.coupon_end_date)}
                    onChange={(e) =>
                      setEditData({
                        ...editData,
                        coupon_end_date: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="flex justify-end gap-3 mt-5">
              <button className="btn bg-gray-300 hover:bg-gray-400" onClick={handleCloseModal}>
                Cancel
              </button>
              <button className="btn bg-blue-500 hover:bg-blue-600" onClick={handleSaveChanges}>
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete (single) */}
      {showDeleteDialog && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white w-[400px] rounded-lg shadow-lg p-[20px] relative">
            <h2 className="text-xl font-bold mb-[10px]">Confirm Deletion</h2>
            <p className="text-sm mb-[20px]">
              Are you sure you want to delete the coupons?
            </p>
            <div className="flex justify-end gap-3">
              <button
                className="btn bg-gray-300 hover:bg-gray-400"
                onClick={cancelDelete}
              >
                Cancel
              </button>
              <button
                className="btn bg-red-500 hover:bg-red-600"
                onClick={() => confirmDeleteCoupon(showDeleteDialog.coupon_id)}
              >
                Confirm Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete (bulk) */}
      {showDeleteSelectedDialog && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white w-[400px] rounded-lg shadow-lg p-[20px] relative">
            <h2 className="text-xl font-bold mb-[10px]">Confirm Deletion</h2>
            <p className="text-sm mb-[20px]">
              Are you sure you want to delete the selected coupons?
            </p>
            <div className="flex justify-end gap-3">
              <button
                className="btn bg-gray-300 hover:bg-gray-400"
                onClick={() => setShowDeleteSelectedDialog(false)}
              >
                Cancel
              </button>
              <button
                className="btn bg-red-500 hover:bg-red-600"
                onClick={confirmDeleteSelectedCoupons}
              >
                Confirm Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
